import { render, staticRenderFns } from "./MproductIntroduce.vue?vue&type=template&id=228e3c36"
import script from "./MproductIntroduce.vue?vue&type=script&lang=js"
export * from "./MproductIntroduce.vue?vue&type=script&lang=js"
import style0 from "./MproductIntroduce.vue?vue&type=style&index=0&id=228e3c36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports